import React, { useContext } from "react";
import UploadArea from "../Form/UploadArea";
import AppContext from "../../context";
import useFileInput from "../Form/useFileInput";

const FileUpload = () => {
  const { myCanvas } = useContext(AppContext);
  const image = useFileInput();

  const handleLoad = (url) => {
    myCanvas.setUploadedImage(url);
  };

  return (
    <div className="upload-section">
      <p>Upload a photo (optional):</p>
      <UploadArea imageRef={image.fileRef} onLoad={handleLoad} />
    </div>
  );
};

export default FileUpload;
